import { render, staticRenderFns } from "./OrticDropZone.vue?vue&type=template&id=513193b3&scoped=true&"
import script from "./OrticDropZone.vue?vue&type=script&lang=js&"
export * from "./OrticDropZone.vue?vue&type=script&lang=js&"
import style0 from "./OrticDropZone.vue?vue&type=style&index=0&id=513193b3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513193b3",
  null
  
)

export default component.exports